import {Component, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-text-field',
  templateUrl: './gelios-text-field.component.html',
})
export class GeliosTextFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  showMaskTyped = false;
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }

  onValueChange(event) {
    super.onValueChange(event);
    this.showMaskTyped = !!event;
  }

  ngOnInit() {
    super.ngOnInit();
    this.showMaskTyped = !!this.reflexiveField.value;
  }
}
